import styled from 'styled-components';
import { spacing, palette } from '@landr/maestro';
import { RouterLink } from 'components/CommonUi/RouterLink';

const Section = styled.section`
    width: 100%;
    text-align: center;
    background-color: ${palette('neutral.200')};
    padding: ${spacing('md')};
`;

const TextWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${spacing('xs')};

    ${({ theme }): string => theme.breakpoint('sm')`
        display: block;
    `}
`;

const LinkContainer = styled(RouterLink)`
    margin-left: ${spacing('xxs')};
    color: ${palette('neutral.500')};
    text-decoration: underline;
`;

const Styled = {
    Section,
    TextWrapper,
    LinkContainer,
};

export default Styled;
